import { render, staticRenderFns } from "./SearchEstimatesPage.vue?vue&type=template&id=0ff2e55a&"
import script from "./SearchEstimatesPage.vue?vue&type=script&lang=js&"
export * from "./SearchEstimatesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports